"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const RQ_icon_gif_1 = __importDefault(require("../assets/RQ-icon.gif"));
const bblFadInOut = styled_components_1.keyframes `
  0%, 80%, 100% { box-shadow: 0 2.5em 0 -1.3em; }
  40% { box-shadow: 0 2.5em 0 0; }
`;
const Loader = styled_components_1.default.div `
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  animation-fill-mode: both;
  animation: ${bblFadInOut} 1.8s infinite ease-in-out;
  color: #000;
  font-size: 7px;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  animation-delay: -0.16s;

  &::before,
  &::after {
    content: '';
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    animation-fill-mode: both;
    animation: ${bblFadInOut} 1.8s infinite ease-in-out;
    position: absolute;
    top: 0;
  }

  &::before {
    left: -3.5em;
    animation-delay: -0.32s;
  }

  &::after {
    left: 3.5em;
  }
`;
const ToggleWrap = styled_components_1.default.div `
	position: absolute;
	z-index: 10;
	width: 100%;
	height: 50vh;
	margin-top: -22vh;
	background-color: ${({ theme }) => theme.white};
	display: ${({ isShowing }) => isShowing ? 'flex' : 'none'};
	justify-content: center;
	align-items: center;
	-webkit-box-shadow: 0 0 100px 300px ${({ theme }) => theme.blackTransparent};
	box-shadow: 0 0 100px 300px ${({ theme }) => theme.blackTransparent};

	img {
		width: 10vw;
		height: 10vw;
		position: absolute;
	}

	@media(max-width: 870px) {
		margin-left: -10px;

		img {
			top: 10%;
			width: 15vw;
			height: 15vw;
		}
	}

	@media(max-width: 41em) {
		img {
			top: 15%;
			width: 20vw;
			height: 20vw;
		}
	}

	@media(max-width: 450px) {
		img {
			top: 15%;
			width: 30vw;
			height: 30vw;
		}
	}

	@media(max-width: 260px) {
		img {
			top: 25%;
			width: 40vw;
			height: 40vw;
		}
	}
`;
const Wrap = styled_components_1.default.div `
	width: 100%;
	height: 50%;
	display: flex;
	justify-content: center;
	align-items: center;

	img {
		width: 10vw;
		height: 10vw;
	}
`;
const defaultProps = {
    screenReaderText: 'Loading page'
};
const Loading = ({ toggle, isShowing, screenReaderText, useGeneralLoader }) => {
    if (useGeneralLoader) {
        return (react_1.default.createElement(Loader, null));
    }
    if (toggle) {
        return (react_1.default.createElement(ToggleWrap, { "data-testid": "loading-gif", className: (isShowing ? 'loading-absolute' : ''), isShowing: isShowing },
            react_1.default.createElement("img", { src: RQ_icon_gif_1.default, alt: "loading" }),
            react_1.default.createElement("span", { role: "status", className: "sr-only" }, screenReaderText)));
    }
    else {
        return (react_1.default.createElement(Wrap, { "data-testid": "loading-gif" },
            react_1.default.createElement("img", { src: RQ_icon_gif_1.default, alt: "loading" }),
            react_1.default.createElement("span", { role: "status", className: "sr-only" }, screenReaderText)));
    }
};
exports.Loading = Loading;
exports.Loading.defaultProps = defaultProps;
